import { t } from "@/i18n";
/**
 * 官网发展历程节点文案。
 * 2017-05 ~ 2021-06 与 Figma 节点 741-3809（收银官网基准文件）及原 webtimeLine 页一致。
 */
export const timelineMilestones = [
  { date: "2017-05", text: t("公司成立，进军零售行业") },
  { date: "2017-09", text: t("公司发展客户数突破1000") },
  { date: "2017-12", text: t("累计服务终端用户数突破1w+") },
  {
    date: "2018-03",
    text: t("发现市场需求，展开为期数月4万终端用户的市场调研+"),
  },
  {
    date: "2018-06",
    text: t("订货商城整体方案设计并确定企业发展方向"),
  },
  {
    date: "2018-10",
    text: t("多名资深开发设计人员加入，初步团队组建完成"),
  },
  {
    date: "2019-03",
    text: t("成立研发团队，公司整体转型自主研发"),
  },
  {
    date: "2019-07",
    text: t("订货商城首次开放内测名额，邀请多家本地龙头企业参与体验"),
  },
  {
    date: "2019-10",
    text: t("订货商城正式上线，获得智百威首轮投资"),
  },
  {
    date: "2020-03",
    text: t("订货商城整体销售额破亿，瞅准零售市场，开始零售商城研发"),
  },
  {
    date: "2020-05",
    text: t("社区团购版本上线，协助企业完成日均10w+销售额的突破"),
  },
  {
    date: "2020-07",
    text: t("零售商城发布，线上企业级客户数破千，终端用户突破20w+"),
  },
  {
    date: "2021-03",
    text: t("收银软件Android发布，获得市场强烈反响"),
  },
  {
    date: "2021-06",
    text: t("快速推出收银Windows版本，小程序线上商城，市场占有率突破性提升"),
  },
  { date: "2022-06", text: t("上线客户突破10000+") },
  {
    date: "2022-08",
    text: t("上线自助收银应用、手机收银功能，让收银变得更简单"),
  },
  {
    date: "2022-11",
    text: t("推出行业首款微商城，可实现一分钟快速上线，商家售货就这么简单"),
  },
];



// WEBPACK FOOTER //
// ./src/data/timelineMilestones.js